const nutritionGuidanceSectionTranslations = {
  generalTutorial: "شرح البرنامج",
  mealTiming: "توقيت الوجبات",
  weightAndMeasurements: "الوزن والقياسات",
  kitchenScale: "ميزان المطبخ",
  dailyWaterIntake: "كمية المياه اليومية",
  sleepingHours: "عدد ساعات النوم",
  recommendedSauces: "صوصات مقترحة",
  recommendedSoftDrinks: "مشروبات غازية مقترحة",
  oil: "الزيت",
  actionButton: "عرض",
};

export default nutritionGuidanceSectionTranslations;
